import Modal from "@/components/modal/modal.vue";

export default {
	props: { note: String },

	components: { Modal },

	data() {
		return { newNote: this.note };
	},

	methods: { handleSave },
};

async function handleSave() {
	this.$emit("save", this.newNote);
	this.$emit("close");
}
